// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3OcZg","alertIcon":"ConfirmModal_alertIcon__FlyaQ"};